import type { ProductData } from '@shared/dream-components/src';

export interface ProductVariant {
  id: string;
  name: string | null;
  status: 'draft' | 'live' | 'archived';
  unit_amount: number;
  currency: string;
  is_default: boolean;
  default_image_url?: string | null;
  stripe_price_id: string | null;
  created_at?: string;
  updated_at?: string;
  created_by_user_id?: string | null;
  updated_by_user_id?: string | null;
  redeemable?: unknown | null;
  price?: string | null;
}

export enum ProductType {
  FILE_DOWNLOAD = 'file',
  LINK_MEDIA = 'link',
  COACHING_SESSION = 'coaching_session',
}

export interface Product {
  id: string;
  name: string;
  description: string | null;
  slug: string;
  status: 'draft' | 'live' | 'archived';
  cta_text: string | null;
  product_type: ProductType | null;
  tiptap_state: ProductData['tiptap_state'];
  stripe_product_id?: string | null;
  created_at: string;
  updated_at: string;
  created_by_user_id?: string | null;
  updated_by_user_id?: string | null;
  default_product_variant?: ProductVariant | null;
  product_variants: ProductVariant[];
}
